import script from "./TableAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./TableAdmin.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__